import { render } from "./admin-user-list.vue?vue&type=template&id=c87b6f78&ts=true"
import script from "./admin-user-list.vue?vue&type=script&lang=ts"
export * from "./admin-user-list.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__